import { compose } from 'redux';
import { connect } from 'react-redux';
import _debounce from 'lodash/debounce';
import URLS from 'constants/urls';
import { withForm } from 'components/Form';
import { selectPike13Data } from './Pike13.selectors';
import { handlePike13FormChange as handlePike13FormChangeAction } from './Pike13.saga';
import Pike13 from './Pike13';

const debouncedHandleChange = _debounce((action, values) => action(values), 1000, { leading: false, trailing: true });

const mapStateToProps = state => {
  const { localStorageData, lastReservationDate, locations, services, isLoading, isSuccess, apiToken } =
    selectPike13Data(state);

  return {
    initialValues: localStorageData,
    lastReservationDate,
    locations,
    services,
    isLoading,
    isSuccess,
    pike13OAuthUrl: URLS.pike13.authorize(URLS.pike13.oAuthRedirect(), apiToken),
  };
};

const mapDispatchToProps = {
  handlePike13FormChange: handlePike13FormChangeAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { handlePike13FormChange, handlePike13LaunchOAuth } = dispatchProps;
  return {
    ...stateProps,
    launchOAuth: handlePike13LaunchOAuth,
    onSubmit: (_, formAsyncFns) => formAsyncFns.resolveSubmit(), // in case the user hits 'enter'
    onChange: values => debouncedHandleChange(handlePike13FormChange, values),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withForm({
    name: 'pike13Migration',
    enableReinitialize: true,
  })
)(Pike13);
